/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ContainerBookingCreationRequestTO {
    'containerBookingId': number;
    'referenceNumber': string;
    'containerNumber'?: string;
    /**
    * Type of a Task
    */
    'type': ContainerBookingCreationRequestTOTypeEnum;
    'isoCode'?: string;
    'customerId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "containerBookingId",
            "baseName": "containerBookingId",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "referenceNumber",
            "baseName": "referenceNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "containerNumber",
            "baseName": "containerNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "ContainerBookingCreationRequestTOTypeEnum",
            "format": ""
        },
        {
            "name": "isoCode",
            "baseName": "isoCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "customerId",
            "baseName": "customerId",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ContainerBookingCreationRequestTO.attributeTypeMap;
    }

    public constructor() {
    }
}


export type ContainerBookingCreationRequestTOTypeEnum = "pickup" | "delivery" ;

